import { WelcomeComponent } from "@/components";

export default {
  name: "About",
  components: {
    WelcomeComponent,
  },
  setup(props) {},
};
